export default __webpack_public_path__ + "static/media/Background_00162.8bee1838.png";